import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import React, { useContext } from 'react';
import iconAdd from '../../assets/images/icons/common/icon-add-gold.png';
import { DialogContext } from '../../context/dialog';
import { UserContext } from '../../context/user';
import { useBuyCrypto } from '../../hooks/imx/use-buy-crypto';
import { DialogType } from '../../types/dialogs';
import { TooltipPosition } from '../../types/tooltips';
import { sliceAddress } from '../../utils/blockchain';
import IconButton from '../common/icon-button';
export default function AddUsdcButton() {
    var t = useI18n().t;
    var buyCrypto = useBuyCrypto().buyCrypto;
    var setDialogProps = useContext(DialogContext).setDialogProps;
    var user = useContext(UserContext).user;
    var handleClickAction = function () {
        setDialogProps({
            common: {
                title: t('common.add-usdc-dialog.title'),
                close: { text: t('common.back'), action: function () { return setDialogProps(undefined); } },
            },
            custom: {
                type: DialogType.SIMPLE,
                message: t('common.add-usdc-dialog.confirmed-message'),
            },
        });
        buyCrypto({ provider: 'moonpay' });
    };
    return (_jsx(IconButton, { className: "usdc-add-more", icon: iconAdd, onClick: function () {
            return setDialogProps({
                common: {
                    title: t('common.add-usdc-dialog.title'),
                    close: { text: t('common.back'), action: function () { return setDialogProps(undefined); } },
                    actions: [
                        {
                            text: t('common.confirm'),
                            action: handleClickAction,
                            highlighted: true,
                        },
                    ],
                },
                custom: {
                    type: DialogType.SIMPLE,
                    message: t('common.add-usdc-dialog.message', {
                        wallet: sliceAddress((user === null || user === void 0 ? void 0 : user.mpcWalletAddress) || ''),
                    }),
                },
            });
        }, tooltip: { message: t('tooltip.add-usdc-via-moonpay'), position: TooltipPosition.RIGHT } }));
}
